module.exports = __webpack_public_path__ + "img/SHORT-SLEEVE-TEE_FRONT_BLUE-FRONT.819f0408.jpg";